import React, { useMemo } from "react";
import { Button } from "@mantine/core";
import { useFormRender } from "../hooks/useFormRender";
import { useTranslation } from "react-i18next";
import { withDefaultIdIssueCountry } from "../helpers/clientIdIssueCountry";
import { useActionRight } from "../hooks/useActionRight";
import { getClientUpdateFormSchema } from "../helpers/getClientUpdateFormSchema";
import { useExtraFieldsFormSchema } from "../hooks/useExtraFieldsFormSchema";

const ClientUpdateActionButton = ({ mainForm }) => {
  const { t } = useTranslation();
  const { isActionEnabled } = useActionRight();
  const canChangeClientStatus = isActionEnabled("client", "enableActive");
  const client = mainForm?.values;
  const baseFormSchema = useMemo(
    () => getClientUpdateFormSchema(t, { canChangeClientStatus, client }),
    [t, canChangeClientStatus, client?._id, client?.code, client?.name]
  );
  const formSchema = useExtraFieldsFormSchema(
    baseFormSchema,
    "Client",
    { layout: "wizard" },
    [t, canChangeClientStatus, client?._id, client?.code, client?.name]
  );

  const onSubmit = async ({ values }) => {
    mainForm.setValues(values);
    return mainForm.saveValues(values);
  };

  const handleActionClick = () => {
    const id = mainForm?.values?._id;
    if (!id) return;
    formAction.open({
      mode: "edit",
      id,
      data: withDefaultIdIssueCountry(mainForm.values),
    });
  };

  const onSubmitSuccess = () => {
    formAction.close();
    mainForm.reload();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    onSubmitSuccess,
    onSubmit
  );
  return (
    <>
      <Button fullWidth onClick={handleActionClick}>
        {t("Update Information")}
      </Button>

      {renderForm()}
    </>
  );
};

export default ClientUpdateActionButton;
